import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl.js";

const API_URL = serverUrl;

export const fetchProductReview = async (productId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/products/${productId}/reviews`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product reviews:", error);
    throw error; // Throw error instead of returning it
  }
};

export const postProductReview = async (productId, data, imageFiles) => {
  const formData = new FormData();

  if (imageFiles.length > 0) {
    imageFiles.forEach((file) => {
      formData.append("files", file);
    });
  }

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      formData.append(key, data[key]);
    }
  }

  const response = await axiosInstance.post(
    `${API_URL}/products/${productId}/reviews`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};
